import Vue from 'vue'
import VueRouter from 'vue-router'

import HomeView from '../views/HomeView.vue'
import About from '../views/AboutView.vue'
import Product from '../views/Product.vue'
import Contact from '../views/Contact.vue'
import Reservation from '../views/Reservation.vue'
import NotFound from '../views/NotFound.vue'
Vue.use(VueRouter)



const routes = [
  {
    path: '/',
    name: 'HomeView',
    component: HomeView,
    meta:{
      title:"三辰服饰"
    }
  },
  {
    path: '/about',
    name: 'about',
    component: About,
    meta:{ title:"关于 - 三辰服饰" }
  },
  {
    path:'/product',
    name:'product',
    component:Product,
    meta:{ title:"产品展示 - 三辰服饰" }
  },
  {
    path:'/contact',
    name:'contact',
    component:Contact,
    meta:{ title:"联系我们 - 三辰服饰" }
  },
  {
    path:'/reservation',
    name:'reservation',
    component:Reservation,
    meta:{ title:"在线预约 - 三辰服饰" }
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('../views/admin/AdminLogin.vue'),
    meta: { title: '后台登录 - 三辰服饰' },
  },
  {
    path: '/admin/products',
    name: 'AdminProducts',
    component: () => import('../views/admin/AdminProducts.vue'),
    meta: { title: '产品管理 - 三辰服饰' },
  },
  {
    path: '/admin/publicize',
    name: 'AdminPublicize',
    component: () => import('../views/admin/AdminPublicize.vue'),
    meta: { title: '首页轮播图管理 - 三辰服饰' },
  },{
    path:'/article/1',
    name:'Article1',
    component: ()=> import('../components/articles/Article1.vue')
  },{
    path:'/article/2',
    name:'Article2',
    component: ()=> import('../components/articles/Article2.vue')
  },{
    path:'/article/3',
    name:'Article3',
    component: ()=> import('../components/articles/Article3.vue')
  },{
    path:'/article/4',
    name:'Article4',
    component: ()=> import('../components/articles/Article4.vue')
  },{
    path:'/article/5',
    name:'Article5',
    component: ()=> import('../components/articles/Article5.vue')
  },{
    path:'/article/6',
    name:'Article6',
    component: ()=> import('../components/articles/Article6.vue')
  },{
    path:'/article/7',
    name:'Article7',
    component: ()=> import('../components/articles/Article7.vue')
  },{
    path:'/article/8',
    name:'Article8',
    component: ()=> import('../components/articles/Article8.vue')
  },{
    path:'/article/9',
    name:'Article9',
    component: ()=> import('../components/articles/Article9.vue')
  },{
    path:'/article/10',
    name:'Article10',
    component: ()=> import('../components/articles/Article10.vue')
  },{
    path: '*',
    name: 'NotFound',
    component: NotFound,
    meta:{ title:"404 - 三辰服饰" }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) return { selector: to.hash }
    return { x: 0, y: 0 }
  },
})

router.afterEach((to) => {
  const title = to.meta && to.meta.title ? to.meta.title : '三辰服饰'
  document.title = title
})

export default router
